export const SELECTED_TENANT = "SELECTED_TENANT";
